import normalizeOcrText from './normalizeOcrText';
import preprocessImage from './preprocessImage';

const getLines = (blocks = []) => (
  Array.isArray(blocks)
    ? blocks.flatMap((block) => (
      block?.paragraphs || []
    )).flatMap((paragraph) => paragraph?.lines || [])
    : []
);

const getWords = (lines = []) => (
  lines.flatMap((line) => line?.words || [])
);

const recognizeImage = async ({ worker, file, processedImage: suppliedProcessedImage = null }) => {
  if (!worker) {
    throw new Error('OCR worker is not ready.');
  }

  const processedImage = suppliedProcessedImage || await preprocessImage(file);
  await worker.setParameters({
    tessedit_pageseg_mode: '3',
    tessedit_char_whitelist: '',
    preserve_interword_spaces: '1',
  });
  const result = await worker.recognize(
    processedImage.canvas,
    {},
    { text: true, blocks: true }
  );
  const data = result?.data || {};
  const lines = getLines(data.blocks);
  const words = getWords(lines);

  return {
    fileName: file?.name || 'Screenshot',
    rawText: normalizeOcrText(data.text || ''),
    confidence: typeof data.confidence === 'number' ? data.confidence : null,
    lines,
    words,
    image: {
      originalWidth: processedImage.originalWidth,
      originalHeight: processedImage.originalHeight,
      width: processedImage.width,
      height: processedImage.height,
      scale: processedImage.scale,
    },
  };
};

export default recognizeImage;
